{
  "manager": {
    "adminFacilityConflictModal": {
      "facilityAlreadyBooked": "Facility Already Booked",
      "schedulingConflict": "Scheduling conflict:",
      "facilitiesAlreadyBooked": "the facilities below are already booked for the selected time.",
      "conflictId": "(ID: {id})",
      "adminOverrideHint": "As an admin you can override and book anyway, or cancel and adjust the booking.",
      "overrideAndBook": "Override & Book Anyway"
    }
  },
  "user": {
    "baseFacilityShow": {
      "membershipsRequired": "MEMBERSHIPS REQUIRED",
      "bookingDuration": "BOOKING DURATION",
      "minAbbrev": "min.",
      "maxAbbrev": ", max.",
      "daysInAdvance": "DAYS IN ADVANCE",
      "youMustBook": "You must book",
      "inAdvance": "in advance.",
      "capacity": "CAPACITY",
      "requiredMembership": "Required membership: {name}",
      "allMembershipsRequired": "All of these memberships are required: {list}",
      "oneMembershipRequired": "One of these memberships is required: {list}"
    },
    "facilityBookingShow": {
      "yourBooking": "Your Booking",
      "cancel": "Cancel",
      "bookingDetails": "Booking details",
      "yourBookingFallback": "Your booking",
      "declined": "Declined",
      "approved": "Approved",
      "starts": "Starts",
      "ends": "Ends",
      "recurringSchedule": "Recurring schedule",
      "reason": "Reason",
      "bookingReference": "Booking reference",
      "bookingInstructions": "Booking Instructions",
      "participants": "Participants",
      "organizer": "Organizer",
      "removeParticipant": "Remove {name}",
      "addPlayingPartner": "Add a playing partner",
      "saving": "Saving…",
      "bookingFull": "This booking is full — {capacity} is the maximum for this facility.",
      "bookingStartedParticipantsLocked": "This booking has started, so participants can no longer be changed.",
      "noBookingFound": "No booking could be found with the given ID.",
      "howToCancel": "How would you like to cancel this booking?",
      "cancelJustThisBooking": "Cancel just this booking",
      "cancelAllBookings": "Cancel all associated bookings in the schedule",
      "repeatsSchedule": "Repeats {frequency} on {days} until {until}",
      "memberAddedToBooking": "Member added to booking.",
      "failedToAddMember": "Failed to add member. Please try again.",
      "memberRemovedFromBooking": "Member removed from booking.",
      "failedToRemoveMember": "Failed to remove member. Please try again.",
      "bookingCancelled": "Booking cancelled.",
      "failedToCancelBooking": "Failed to cancel booking. Please try again.",
      "pageTitle": "Your Booking"
    }
  },
  "guest": {
    "facilityBookingShow": {
      "yourBooking": "Your Booking",
      "details": "Details",
      "currentStatus": "Current Status",
      "declined": "Declined",
      "approved": "Approved",
      "requestId": "Request ID",
      "participants": "Participants",
      "startDate": "Start Date",
      "endDate": "End Date",
      "bookableImage": "Bookable Image",
      "noBookingFound": "No booking could be found with the given ID.",
      "pageTitle": "View Booking"
    }
  }
}
